let tail: Promise<void> = Promise.resolve()
let depth = 0

/**
 * Один En на все формы. Слушатели не должны пересекаться: иначе
 * reloadPanel(4267) заказа и updateRegistry главной делят слот,
 * и следующий reloadPanel(4270) уходит в снятый core.
 *
 * Очередь не реентерабельна. runEvent из уже идущего скрипта
 * (en.reloadForm) вызывает тело напрямую, не через эту очередь.
 */
export function runWithPlatformEn<T>(task: () => Promise<T> | T): Promise<T> {
  let release!: () => void
  const gate = new Promise<void>((resolve) => {
    release = resolve
  })
  const prev = tail
  tail = prev.then(() => gate)

  return prev.then(async () => {
    depth += 1
    try {
      return await task()
    } finally {
      depth -= 1
      release()
    }
  })
}

export function platformEnTurnDepth(): number {
  return depth
}

/** @internal */
export function _resetPlatformEnTurnForTests(): void {
  tail = Promise.resolve()
  depth = 0
}
